import React from 'react';
import ReactDOM from 'react-dom';
import { liveRegion, politeLiveRegion, POLITE, ASSERTIVE } from '@instructure/quiz-common';
import { Provider } from '../react-redux';
import Alerts from '../components/alerts';

// alert has to be in the html on render in
// order for screenreaders to pick up on role="alert",
// so we're rendering a sub-app into it so that so that
// we dont accidentally remove it with react

export function renderAlerts(store) {
  ReactDOM.render(/*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(Alerts, {
    politeness: ASSERTIVE
  })), liveRegion());
  if (politeLiveRegion()) {
    ReactDOM.render(/*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(Alerts, {
      politeness: POLITE
    })), politeLiveRegion());
  }
}
export default renderAlerts;